import { Positions } from ".";

type Config = {
  parentBox: ClientRect;
  triggerBox: ClientRect;
  positions: Positions;
  offset: { x: number; y: number };
};

function getLayerPosition(
  config: Config
): { style: React.CSSProperties; translate: { x: any; y: any } } {
  const { parentBox, triggerBox, positions, offset } = config;

  const style: React.CSSProperties = {};

  let x = "0%";
  let y = "0%";

  // Y axis
  if (positions.parent[1] === "top") {
    if (positions.layer[1] === "top") {
      style.top = triggerBox.top + offset.y;
    } else {
      style.top = triggerBox.top - offset.y;
      y = "-100%";
    }
  } else if (positions.parent[1] === "bottom") {
    if (positions.layer[1] === "top") {
      style.top = triggerBox.bottom + offset.y;
    } else {
      style.top = triggerBox.bottom + offset.y;
      y = "-100%";
    }
  }

  // correct with parentBox
  style.top = (style.top as number) - parentBox.top;

  // X axis
  if (positions.parent[0] === "left") {
    if (positions.layer[0] === "left") {
      style.left = triggerBox.left + offset.x;
    } else {
      style.left = triggerBox.left + offset.x;
      x = "-100%";
    }
  } else if (positions.parent[0] === "right") {
    if (positions.layer[0] === "left") {
      style.left = triggerBox.right + offset.x;
    } else {
      style.left = triggerBox.right + offset.x;
      x = "-100%";
    }
  }

  // correct with parentBox
  style.left = (style.left as number) - parentBox.left;

  style.transform = `translate(${x}, ${y})`;

  return {
    style,
    translate: {
      x,
      y
    }
  };
}

export default getLayerPosition;
